import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import Header from "../sections/Header";
import Sidebar from "../sections/Sidebar";
import { encStorage } from "../hooks/encStorage";
import { POST_TRANSACTION } from "../services/Apis";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const CreateRedeemCommission = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const redeemCommission = location.state?.walletBalance || 0;

  const [SidebarState, setSidebarState] = useState(false);
  const [loading, setLoading] = useState(true);
  const [banks, setBanks] = useState([]);
  const [amtValidation, setAmtValidation] = useState("");
  const [amount, setAmount] = useState(redeemCommission);
  const [minAmount, setminAmount] = useState(500);

  const updateSidebarState = (newState) => {
    setSidebarState(newState);
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    if (value < minAmount) {
      setAmount(value);
      setAmtValidation("Minimum Amount for Redeem should be " + minAmount);
    } else if (value > redeemCommission) {
      setAmount(value);
      setAmtValidation(
        "Minimum Amount available for Redemption is " + redeemCommission
      );
    } else {
      setAmount(value);
      setAmtValidation("");
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const token = encStorage.getItem("token");
    const formData = new FormData();
    formData.append("amount", amount);
    if (amount < minAmount) {
      setAmtValidation("Minimum Amount for Credit should be " + minAmount);
      return false;
    }
    formData.append("transaction_type", 4);

    try {
      await axios.post(POST_TRANSACTION, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      navigate("/", {
        state: {
          message: "Commission redeemed successfully!",
          status: 200,
        },
      });
    } catch (error) {
      navigate("/", {
        state: { message: "Error during Credit!", status: 400 },
      });
    }
  };

  return (
    <>
      <Header updateState={updateSidebarState} />
      <div id="layoutSidenav">
        <Sidebar props={SidebarState} />
        <div id="layoutSidenav_content" className="layout-content">
          <main>
            <div className="container-fluid px-4">
              <div className="d-flex">
                <h3 className="mt-4 w-75">Redeem Commission</h3>
                <div className="mt-auto me-0 mb-2 w-25 d-flex justify-content-end">
                  <Link to="/" className="btn btn-primary" title="New">
                    <span className="d-md-inline">Back</span>
                  </Link>
                </div>
              </div>
              <div className="card mb-4">
                <div className="card-body">
                  <form
                    id="withdrawform"
                    method="POST"
                    encType="multipart/form-data"
                    onSubmit={handleFormSubmit}
                  >
                    <div className="row">
                      <div className="form-group col-sm-6">
                        <label>Amount</label>
                        <div className="input-group">
                          <select className="form-control" value="113" disabled>
                            <option value="113">₹</option>
                          </select>
                          <input
                            type="number"
                            className="form-control w-75"
                            id="amount"
                            placeholder="Enter Amount"
                            value={amount}
                            onChange={handleAmountChange}
                            required
                          />
                          <p id="amtValidation" className="text-danger fs-6">
                            {amtValidation}
                          </p>
                        </div>
                      </div>
                    </div>
                    <button type="submit" className="btn btn-primary mt-5">
                      Submit
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default CreateRedeemCommission;
